import { useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative flex min-h-[70vh] flex-col items-center justify-center px-4 pb-24 pt-32 text-center">
      <h1 className="pointer-events-none absolute bottom-0 z-0 select-none text-8xl font-black text-background-200 md:text-[12rem]">
        404
      </h1>
      <div className="relative z-10">
        <p className="font-label text-xs font-semibold uppercase tracking-[0.22em] text-primary-700">
          Page not found
        </p>
        <h2 className="mt-4 text-xl font-semibold text-foreground-950 md:text-2xl">
          This page has not been generated
        </h2>
        <p className="mt-2 font-mono text-sm text-foreground-500">{location.pathname}</p>
        <p className="mt-4 text-base text-foreground-600">
          Tell me more about this page, so I can generate it
        </p>
      </div>
    </div>
  );
}